import { render, staticRenderFns } from "./approvalFooter.vue?vue&type=template&id=2823f4c0&scoped=true&"
import script from "./approvalFooter.vue?vue&type=script&lang=js&"
export * from "./approvalFooter.vue?vue&type=script&lang=js&"
import style0 from "./approvalFooter.vue?vue&type=style&index=0&id=2823f4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823f4c0",
  null
  
)

export default component.exports